import React, { useEffect, useState } from 'react'

function Timer({ handleClick }) {
    const [seconds, setSeconds] = useState(120)
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    useEffect(() => {
        if (seconds > 0) {
            const interval = setInterval(() => {
                setSeconds((seconds) => seconds - 1)
            }, 1000)

            return () => clearInterval(interval)
        }
    }, [seconds])

    const handleRetry = () => {
        handleClick()
        setSeconds(120)
    } 

    return (
        <div>
            {seconds === 0 ? (
                <p className=" text-center text-green-700 text-base font-medium cursor-pointer hover:brightness-125" onClick={handleRetry}>
                    ارسال مجدد
                </p>
            ) : (
                <p className=" text-center text-green-700 text-base font-medium">
                    ارسال مجدد کد پس از : {minutes}:
                    {remainingSeconds < 10 ? "0" : ""}
                    {remainingSeconds}
                    دقیقه
                </p>
            )}
        </div>
    )
}

export default Timer